import routerUser from "@/router/routes/user.js";
import routerLogin from "@/router/routes/login.js";

const routes = [
	{
		path: "/",
		component: () => import("@/views/main/Index"),
		meta: { layout: "Blank"},
		beforeEnter: () => {
      history.back();
    },
	},
	...routerUser,
	...routerLogin,
];

export {
	routes
};
